import { useT } from './t';

/**
 * Relative-time label for a unix-ms timestamp ("vor 2 min" / "2 min ago"), in the
 * current locale. 0 / falsy → "Nie" / "Never".
 */
export function useRelTime() {
  const tc = useT('common');
  return (ms: number): string => {
    if (!ms) return tc('never');
    const s = Math.max(0, Math.round((Date.now() - ms) / 1000));
    if (s <= 5) return tc('justNow');
    if (s < 60) return tc('secondsAgo', { n: s });
    const m = Math.round(s / 60);
    if (m < 60) return tc('minutesAgo', { n: m });
    const h = Math.round(m / 60);
    if (h < 24) return tc('hoursAgo', { n: h });
    return tc('daysAgo', { n: Math.round(h / 24) });
  };
}
